import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NotFound from 'pages/Projets/DigiFor/Presfor/NotFound';
import { ProtectedRoute } from 'components/componentsPresfor';

import AttestationValidationEnqueteFonciere from 'pages/Projets/DigiFor/Presfor/Delimitations/AttestationValidationEnqueteFonciere';
import PageAttestationValidationEnqueteFonciere from 'pages/Projets/DigiFor/Presfor/Delimitations/AttestationValidationEnqueteFonciere/page';
import Home from 'pages/Projets/DigiFor/Presfor/Home';

const ErrorBoundary = React.lazy(
  () => import('components/componentsPresfor/Error')
);

const Resumecontrat = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Contrats/Resumecontrat')
);
const AddCF = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Certifications/AddCF')
);
const EditCF = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Certifications/EditCF')
);
const AddFicheIdentification = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Certifications/CF2')
);
const AddCFInfo = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Certifications/AddCFInfo')
);

const PSFCPRESFORlivrablescf = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/PSFCPRESFORlivrablescf')
);

const PSFCPRESFORLivrablesCloture = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Clotures/PSFCPRESFORLivrablesCloture')
);

const ConsolidationAttestationFormationAEFJ = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/ConsolidationDispositifs/AttestationFormationAEFJ')
);

const ConsolidationAttestationFormationAEFC = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/ConsolidationDispositifs/AttestationFormationAEFC')
);

const PSFCPRESFORLivrablesConsolidation = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/ConsolidationDispositifs/PSFCPRESFORLivrablesConsolidation')
);

const PSFCPRESFORLivrablesConsolidationDroits = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/ConsolidationDroits/PSFCPRESFORLivrablesConsolidationDroits')
);

const PSFCPRESFORlivrablesIngenieurieSociaux = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/PSFCPRESFORlivrablesIngenieurieSociaux')
);

const PSFCPRESFORlivrablesIngenieurieSociauxValides = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/PSFCPRESFORlivrablesIngenieurieSociauxValides')
);

const PSFCPRESFORlivrablesIngenieurieSociauxRejete = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/PSFCPRESFORlivrablesIngenieurieSociauxRejete')
);

const PSFCPRESFORlivrablesIngenieurieSociauxEnCours = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/PSFCPRESFORlivrablesIngenieurieSociauxEnCours')
);

const PSFCPRESFORlivrablesIngenieurieSociauxRevus = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/PSFCPRESFORlivrablesIngenieurieSociauxRevus')
);

const PSFCPRESFORlivrablesIngenieurieSociauxSousPrefecture = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/SousPrefecture/PSFCPRESFORlivrablesIngenieurieSociauxSousPrefecture')
);

const PSFCPRESFORLivrablesSensibilisation = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Sensibilisations/PSFCPRESFORLivrablesSensibilisation')
);

const PSFCPRESFORLivrablesDelimitation = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Delimitations/PSFCPRESFORLivrablesDelimitation')
);

const PSFCPRESFORLivrablesDelimitationValide = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Delimitations/PSFCPRESFORLivrablesDelimitationValide')
);

const PSFCPRESFORLivrablesDelimitationNonValide = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Delimitations/PSFCPRESFORLivrablesDelimitationNonValide')
);

const PSFCPRESFORLivrablesDelimitationRejete = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Delimitations/PSFCPRESFORLivrablesDelimitationRejete')
);

const PSFCPRESFORLivrablesDelimitationRevus = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Delimitations/PSFCPRESFORLivrablesDelimitationRevus')
);

const PSFCPRESFORlivrablesIngenieurieSociauxDecisionCreation = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/Diagnostic-cvgfr/Decision-creation-cvgfr/index')
);

// const PSFCPRESFORISFResolutionsdesReunionsCSPISF = React.lazy(() =>
//   import(
//     'pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/DecisionSousPrefectorale/ResolutionsdesReunionsCSPISF'
//   )
// );

// const PSFCPRESFORISFDesignationActivitesDialogueSocial = React.lazy(() =>
//   import(
//     'pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/DecisionSousPrefectorale/DesignationActivitesDialogueSocial'
//   )
// );

const PSFCPRESFORlivrablesIngenieurieSociauxProcesVerbal = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/Diagnostic-cvgfr/Proces-verbal-de-constitution/index')
);

// const PSFCPRESFORlivrablesIngenieurieSociauxDecisionSousPrefectoral = React.lazy(() =>
//   import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/DecisionSousPrefectorale/index')
// );

const PSFCPRESFORlivrablesIngenieurieSociauxDiagnosticCvgfrLivrable =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/Diagnostic-cvgfr/Livrable-cvgfr/index')
  );

const PSFCPRESFORlivrablesIngenieurieSociauxAttestationFormationCvgfr =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/FormationMembreCVGFR/AttestationFormationCvgfr/index')
  );
const PSFCPRESFORLivrablespresforResolutionReunionsCspisf = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/ReunionPeriodriqueComiteSousPrefectoralIgnierieSocioFonciere/PresforResolutionReunionsCspisf/index')
);
const PSFCPRESFORlivrablespresforProceduresEtablissementEtatCivil = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/PresforProceduresEtablissementEtatCivil/index')
);
const PSFCPRESFORlivrablespresforProceduresEtablissementEtatCivilCreate =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/PresforProceduresEtablissementEtatCivil/create/index')
  );
const PSFCPRESFORlivrablespresforEnqueteOrganisationSocioFonciere = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/EnqueteOrganisationSocioFonciere/index')
);

const PSFCPRESFORlivrablesIngenieurieSociauxInformationSensibilisation =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFComplementaire/InformationSensibilisation/index')
  );

// const Addlettretransmission = React.lazy(() =>
//   import('pages/Projets/DigiFor/Presfor/')
// );
const PSFCPRESFORENQCF = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Certifications/PSFCPRESFORENQCF')
);
const DossierNonValides = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/PSFCPRESFORENQCF/DossierNonValides')
);
const DemandeEnqCF = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Certifications/CF1/DemandeEnqCF')
);
const InfoOPTCF = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Certifications/CF1/InfoOPTCF')
);
const PUB = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Certifications/PUB')
);
const AddOuverturePub = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF20/AddOuverturePub')
);
const AddEnqueteOuverturePub = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF20/AddEnqueteOuverturePub')
);
const AddAnnexesOuverturePub = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF20/AddAnnexesOuverturePub')
);
const AddCf19 = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Certifications/CF19/AddCf19')
);
const CF20 = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Certifications/CF20')
);
const AddPVPub = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Certifications/CF9/AddPVPub')
);
const AddAnnexesPVPub = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF9/AddAnnexesPVPub')
);
const CF9 = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Certifications/CF9')
);
const CF8 = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Certifications/CF8')
);
const AddAnnoncePub = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Certifications/CF8/AddAnnoncePub')
);
const AddAnnexesAnnoncePub = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF8/AddAnnexesAnnoncePub')
);
const FicheLitigesCF = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF3/FicheLitigesCF')
);
const ListeDesServitudes = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF3/ListeDesServitudes')
);
const DocumentsAnnexePVRDC = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF3/DocumentsAnnexePVRDC')
);
const ModalUploadDocumentsAnnexePVRDC = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF3/ModalUploadDocumentsAnnexePVRDC')
);
const EtatDesDroitsDeProp = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF3/EtatDesDroitsDeProp')
);
const ListeDetenteursDeDroitsCF = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF3/ListeDetenteursDeDroitsCF')
);
const PVRDCTemplate = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Certifications/Templates/PVRDC')
);
const ListeDesAyantsDroitsCF = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF3/ListeDesAyantsDroitsCF')
);
const GestionnaireCF = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF3/DesignationGestionnaireCF/GestionnaireCF')
);

const CF19 = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Certifications/CF19')
);
const CF11 = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Certifications/CF11')
);
const AddAnnexesValidation = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF11/AddAnnexesValidation')
);
const AddValidation = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF11/AddValidation')
);
const AddValidationAnnonce = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF11/AddValidationAnnonce')
);
const AddAnnexesValidationAnnonce = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF11/AddAnnexesValidationAnnonce')
);
const EditValidationAnnonce = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF11/EditValidationAnnonce')
);
const EditAnnexesValidationAnnonce = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF11/EditAnnexesValidationAnnonce')
);
const CF10 = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Certifications/CF10')
);

const UpdateGestionnaireCF = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF3/DesignationGestionnaireCF/GestionnaireCF/update')
);

const AddAnnexesCECPDC = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF10/AddAnnexesCECPDC')
);
const AddCECPDC = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Certifications/CF10/AddCECPDC')
);
const EditCECPDC = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Certifications/CF10/EditCECPDC')
);
const EditAnnexesCECPDC = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF10/EditAnnexesCECPDC')
);
const AddCECPDCDcf = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Certifications/CF10/AddCECPDCDcf')
);
const EditCECPDCDcf = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF10/EditCECPDCDcf')
);
const AddAnnexesCECPDCDcf = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF10/AddAnnexesCECPDCDcf')
);
const EditAnnexesCECPDCDcf = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF10/EditAnnexesCECPDCDcf')
);
const SignatairesDesignationGestionnaire = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF3/DesignationGestionnaireCF/SignatairesDesignationGestionnaire')
);
const CF4 = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Certifications/CF4')
);
const AddAnnexesPVCL = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF4/AddAnnexesPVCL')
);
const AddDemandePVCLAnnexes = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF4/AddDemandePVCL/pvcl-annexe')
);
const AddPVCL = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Certifications/CF4/AddPVCL')
);
const AddRapportNonParticipation = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF4/AddRapportNonParticipation')
);
const FormulairePage1 = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF4/AddRapportNonParticipation/FormulairePage1')
);
const FormulairePage2 = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF4/AddRapportNonParticipation/FormulairePage2')
);
const AddDemandePVCL = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF4/AddDemandePVCL')
);
const DemandePVCL = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF4/AddDemandePVCL/pvcl')
);
const CF12 = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Certifications/CF12')
);
const AddAnnexesCLP = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF12/AddAnnexesCLP')
);
const AddCLP = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Certifications/CF12/AddCLP')
);
const PVRDC = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Certifications/CF3/PVRDC')
);
const ListePVRDC = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Certifications/CF3/ListePVRDC')
);
const FicheDemographiqueCF = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF3/FicheDemographiqueCF')
);
const AutresDeclarationsCF = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF3/DeclarationPrsAuditionneesCF/AutresDeclarationsCF')
);
const InfoOccupantsParcelle = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF3/InfoOccupantsParcelle')
);
const QuestionnaireCF = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF3/QuestionnaireCF')
);
const CF1 = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Certifications/CF1')
);
const PSFCPRESFOREnqPromoContratenqueteCreee = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Enquete/PSFCPRESFOREnqPromoContratenqueteCreee')
);
const PSFCPRESFOREnqPromoContratenqueteListPrefecture = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Enquete/PSFCPRESFOREnqPromoContratenqueteListPrefecture')
);
const PSFCPRESFORcreerEnqute = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Enquete/PSFCPRESFORcreerEnqute')
);
const PSFCProfil = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Connexion/PSFCProfil')
);
const PSFCMenuprofil = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Connexion/PSFCMenuprofil')
);

const PSFCPRESFOREnqPromoContratContratdonationpTenUpdate = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Contrats/PSFCPRESFOREnqPromoContratContratdonationpTen/update')
);
const PSFCPRESFOREnqPromoContratContratdonationpTen = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Contrats/PSFCPRESFOREnqPromoContratContratdonationpTen')
);
const PSFCPRESFOREnqPromoContratContratdonationpNineUpdate = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Contrats/PSFCPRESFOREnqPromoContratContratdonationpNine/update')
);
const PSFCPRESFOREnqPromoContratContratdonationpNine = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Contrats/PSFCPRESFOREnqPromoContratContratdonationpNine')
);
const PSFCPRESFOREnqPromoContratContratdonationpEightUpdate = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Contrats/PSFCPRESFOREnqPromoContratContratdonationpEight/update')
);
const PSFCPRESFOREnqPromoContratContratdonationpEight = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Contrats/PSFCPRESFOREnqPromoContratContratdonationpEight')
);
const PSFCPRESFOREnqPromoContratContratdonationpSevenUpdate = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Contrats/PSFCPRESFOREnqPromoContratContratdonationpSeven/update')
);
const PSFCPRESFOREnqPromoContratContratdonationpSeven = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Contrats/PSFCPRESFOREnqPromoContratContratdonationpSeven')
);
const PSFCPRESFOREnqPromoContratContratdonationpSixUpdate = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Contrats/PSFCPRESFOREnqPromoContratContratdonationpSix/update')
);
const PSFCPRESFOREnqPromoContratContratdonationpSix = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Contrats/PSFCPRESFOREnqPromoContratContratdonationpSix')
);
const PSFCPRESFOREnqPromoContratContratdonationpFiveUpdate = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Contrats/PSFCPRESFOREnqPromoContratContratdonationpFive/update')
);
const PSFCPRESFOREnqPromoContratContratdonationpFive = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Contrats/PSFCPRESFOREnqPromoContratContratdonationpFive')
);
const PSFCPRESFOREnqPromoContratContratdonationpFourUpdate = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Contrats/PSFCPRESFOREnqPromoContratContratdonationpFour/update')
);
const PSFCPRESFOREnqPromoContratContratdonationpFour = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Contrats/PSFCPRESFOREnqPromoContratContratdonationpFour')
);
const PSFCPRESFOREnqPromoContratContratdonationpThreeUpdate = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Contrats/PSFCPRESFOREnqPromoContratContratdonationpThree/update')
);
const PSFCPRESFOREnqPromoContratContratdonationpThree = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Contrats/PSFCPRESFOREnqPromoContratContratdonationpThree')
);
const PSFCPRESFOREnqPromoContratContratdonationpTwo = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Contrats/PSFCPRESFOREnqPromoContratContratdonationpTwo')
);
const PSFCPRESFOREnqPromoContratContratdonationpTwoUpdate = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Contrats/PSFCPRESFOREnqPromoContratContratdonationpTwo/update')
);
const Addcontratone = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Contrats/Addcontratone')
);
const Addcontratoneupdate = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Contrats/Addcontratone/update')
);
const ContratPlantationAgroforesterie = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Contrats/PlantationAgroforesterie')
);
const ContratTerreAgroforesterie = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Contrats/TerreAgroforesterie')
);
const ContratRecolteAgroforesterie = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Contrats/RecolteAgroforesterie')
);
const ContratLocationAgroforesterie = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Contrats/LocationAgroforesterie')
);
const ContratMetayageAgroforesterie = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Contrats/MetayageAgroforesterie')
);
const ContratGarantieAgroforesterie = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Contrats/GarantieAgroforesterie')
);
const ContratPretAgroforesterie = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Contrats/PretAgroforesterie')
);
const ContratJachereAgroforesterie = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Contrats/JachereAgroforesterie')
);
const ContratLocationAgriElevage = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Contrats/LocationAgriElevage')
);
const ContratLocationPaturagePermanent = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Contrats/LocationPaturagePermanent')
);
const ContratLocationPaturageSaisonnier = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Contrats/LocationPaturageSaisonnier')
);
const ContratSousLocationPaturageSaisonnier = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Contrats/SousLocationPaturageSaisonnier')
);
const ContratPretAgriElevage = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Contrats/PretAgriElevage')
);
const ContratPretPaturagePermanent = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Contrats/PretPaturagePermanent')
);
const ContratPretPaturageSaisonnier = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Contrats/PretPaturageSaisonnier')
);
const ContratSousPretPaturageSaisonnier = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Contrats/SousPretPaturageSaisonnier')
);
const ContratPretCollectiviteTerritoriale = React.lazy(
  () =>
    import(
      'pages/Projets/DigiFor/Presfor/Contrats/PretCollectiviteTerritoriale'
    )
);

const listeAnnexesContrat = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Contrats/PSFCPRESFORListeAnnexesContrat')
);
const PSFCPRESFOREnqPromoContrataddContrat = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Contrats/PSFCPRESFOREnqPromoContrataddContrat')
);
const PSFCPRESFOREnqPromoContratUpdateContrat = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Contrats/PSFCPRESFOREnqPromoContrataddContrat/update')
);
const PSFCPRESFOREnqPromoContrat = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Contrats/PSFCPRESFOREnqPromoContrat')
);
const PSFCPRESFOR = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Enquete/PSFCPRESFOR')
);
const PSFCProjets = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/PSFCProjets')
);
const ServicesDemande = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/NosServices/demandes')
);
const FUProjets = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/FUProjets')
);
const OtherProjets = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/OtherProjets')
);
const Projets = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Projets')
);
const PSFCReinitialisermdp = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Connexion/PSFCReinitialisermdp')
);
const PSFCMdpoublie = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Connexion/PSFCMdpoublie')
);
const PSFCSeconnecter = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Connexion/PSFCSeconnecter')
);
const PSFCSignin = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Connexion/PSFCSignin')
);
const PSFCHome = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/PSFCHome')
);
const Client = React.lazy(() => import('pages/Projets/DigiFor/Presfor/Client'));
const ClientStep1 = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Client/step1.jsx')
);
const ClientStep2 = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Client/step2.jsx')
);
const ClientStep3 = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Client/step3.jsx')
);
const ClientStep4 = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Client/step4.jsx')
);
const ExpertHome = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/ExpertHome/homeExpert')
);

const PSFCPRESFORmodelepagevalidationcontratspageValidationSix = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Validations/PSFCPRESFORmodelepagevalidationcontratspageValidationSix')
);
const PSFCPRESFORmodelepagevalidationcontratspageValidation1 = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Validations/PSFCPRESFORmodelepagevalidationcontratspageValidation1')
);
const PSFCPRESFORmodelepagevalidationcontratspageValidationOne1 = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Validations/PSFCPRESFORmodelepagevalidationcontratspageValidationOne1')
);
const PSFCPRESFORmodelepagevalidationcontratspageValidationFour1 = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Validations/PSFCPRESFORmodelepagevalidationcontratspageValidationFour1')
);
const PSFCPRESFORmodelepagevalidationcontratspageValidationFour = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Validations/PSFCPRESFORmodelepagevalidationcontratspageValidationFour')
);
const PSFCPRESFORmodelepagevalidationcontratspageValidationThree = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Validations/PSFCPRESFORmodelepagevalidationcontratspageValidationThree')
);
const PSFCPRESFORmodelepagevalidationcontratspageValidationTwo = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Validations/PSFCPRESFORmodelepagevalidationcontratspageValidationTwo')
);
const PSFCPRESFORmodelepagevalidationcontratspageValidationFive = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Validations/PSFCPRESFORmodelepagevalidationcontratspageValidationFive')
);
const PSFCPRESFORmodelepagevalidationcontratsRejetCGEDS = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Validations/PSFCPRESFORmodelepagevalidationcontratsRejetCGEDS')
);
const PSFCPRESFORmodelepagevalidationcontratspageValidationOne = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Validations/PSFCPRESFORmodelepagevalidationcontratspageValidationOne')
);

const PageCloturePubEnqueteDtv = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Delimitations/CloturePubEnqueteDtv')
);

const DTVAddHistoriqueConstitution = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Delimitations/HistoriqueDeConstitution')
);

const DTVAddConstatLimiteTroncon = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Delimitations/ConstatLimiteTroncon/index')
);

const DTVAddConstatLimiteTronconCreate = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Delimitations/ConstatLimiteTroncon/create/index')
);

const DTVAddRapportActivites = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Delimitations/RapportActivites/index')
);

const DTVAddRapportActivitesCreate = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Delimitations/RapportActivites/create/index')
);

const DTVAddScanDocument = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Delimitations/ScanDocument/index')
);

const DTVAddScanDocumentCreate = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Delimitations/ScanDocument/create/index')
);

const DTVOuverturePublicite = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Delimitations/OuverturePublicite')
);

const DTVAnnoncePublicite = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Delimitations/AnnoncePublicite')
);

const DTVAddHistoriqueConstitutionListePresence = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Delimitations/HistoriqueDeConstitution/add-liste-presence')
);

const DTVAddOuverturePubliciteListePresence = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Delimitations/OuverturePublicite/add-liste-presence')
);

const DTVAttestationApprobationEnquete = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Delimitations/AttestationApprobationEnquete')
);

const PSFCPRESFORlivrablesIngenieurieSociauxCahiersIntentionsCF = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/Cahiers-intentions/Certificat-foncier/index')
);

const PSFCPRESFORlivrablesIngenieurieSociauxCahiersIntentionsContrat =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/Cahiers-intentions/Contrat/index')
  );

const PSFCPRESFORlivrablesIngenieurieSociauxDeclarationOuvertureOperations =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/Declaration-ouverture-operation/index')
  );

const PSFCPRESFORlivrablesIngenieurieSociauxDeclarationOuvertureOperationsSousPrefecture =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/SousPrefecture/Declaration-ouverture-operation/index')
  );

const PSFCPRESFORlivrablesIngenieurieSociauxSousPrefectureListeDeclaration =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/SousPrefecture/Declaration-ouverture-operation/list-declaration')
  );

const PSFCPRESFORlivrablesIngenieurieCourrierTransSociauxSousPrefecture =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/SousPrefecture/CourrierTransmission/index')
  );

const PSFCPRESFORlivrablesIngenieurieSociauxReglementInterieurCvgfr =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/FormationMembreCVGFR/ReglementInterieurCvgfr/index')
  );

const PSFCPRESFORlivrablesIngenieurieSociauxRapportSurLeDeroulementDesActivités =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/RapportSurLeDeroulementDesActivités/index')
  );

const PSFCPRESFORlivrablesIngenieurieSociauxFonciereActivitesDeFacilitation =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFComplementaire/ActivitesDeFacilitation/index')
  );
const PSFCPRESFORlivrablesIngenieurieSociauxFonciereFormationEncadrement =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFComplementaire/FormationEncadrement/index')
  );

const PSFCPRESFORlivrablesIngenieurieSociauxReunionPeriodiqueDecisionSousPrefectorale =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/ReunionPeriodriqueComiteSousPrefectoralIgnierieSocioFonciere/ReunionPeriodiqueDecisionSousPrefectorale/index')
  );

const PSFCPRESFORlivrablesIngenieurieSociauxReunionPeriodiqueSousPrefectorale =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/SousPrefecture/Resume-resolution/index')
  );

const PSFCPRESFORlivrablesIngenieurieSociauxReunionPeriodiqueDecisionSousPrefectoraleSousPrefectureCreate =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/SousPrefecture/ReunionPeriodiqueDecisionSousPrefectorale/create/index')
  );

const PSFCPRESFORlivrablesIngenieurieSociauxReunionPeriodiqueDecisionSousPrefectoraleSousPrefecture =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/SousPrefecture/ReunionPeriodiqueDecisionSousPrefectorale/index')
  );

const PSFCPRESFORPresforListePresenceFormationCvgfr = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/FormationMembreCVGFR/PresforListePresenceFormationCvgfr/index')
);

const PSFCPRESFORlivrablesIngenieurieSociauxCalendrierOuverture = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/PriseDeContact/Calendrier-ceremonie-ouverture/index')
);
const PSFCPRESFORlivrablesIngenieurieSociauxPriseDeContactCompteRendu =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/PriseDeContact/CompteRendu/index')
  );

const PSFCPRESFORlivrablesIngenieurieSociauxPriseDeContactCompteRenduSousPrefecture =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/SousPrefecture/PriseDeContact/index')
  );

const PSFCPRESFORlivrablesIngenieurieSociauxPriseDeContactListeDePresence =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/PriseDeContact/ListeDePresence/index')
  );

const PSFCPRESFORlivrablesIngenieurieSociauxPriseDeContactListeDePresenceSousPrefecture =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/SousPrefecture/PriseDeContact/ListeDePresence/index')
  );

const PSFCPRESFORlivrablesIngenieurieSociauxPriseDeContactListeDePresenceRecueil =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/PriseDeContact/ListeDePresenceRecueil/index')
  );

const PSFCPRESFORlivrablesIngenieurieSociauxPriseDeContactRecueilDonneesPersonnelles =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/PriseDeContact/RecueilDonneesPersonnelles/index')
  );

const PSFCPRESFORlivrablesIngenieurieSociauxPriseDeContactRecueilDonneesPersonnellesSousPrefecture =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/SousPrefecture/RecueilDonneePersonnel/list-recueil')
  );

const PSFCPRESFORlivrablesIngenieurieSociauxPriseDeContactRecueilDonneesPersonnellesSousPrefectureCreate =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/SousPrefecture/RecueilDonneePersonnel/create')
  );

const PSFCPRESFORlivrablesIngenieurieSociauxCeremonieOuverture = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/Ceremonie-ouverture/Model-propose-ceremonie-ouverture/index')
);

const PSFCPRESFORlivrablesIngenieurieSociauxCompteRendu = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/Ceremonie-ouverture/Model-propose-compte-rendu/index')
);

const PSFCPRESFORlivrablesIngenieurieSociauxRapportIsfVillage = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/Ceremonie-ouverture/Rapport-isf-village/index')
);

const PSFCPRESFORlivrablesIngenieurieReunionComiteSousPrefectoral = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/ReunionComiteSousPrefectoral/index')
);
const PSFCPRESFORlivrablesIngenieurieSociauxCalendrierPrevisionnelActivites =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/ActivitesDialogueRenforceMemorandum/CalendrierPrevisionnelActivites/index')
  );
const PSFCPRESFORlivrablesIngenieurieSociauxCharteRelationTuteurPlanteur =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/ActivitesDialogueRenforceMemorandum/CharteRelationTuteurPlanteur/index')
  );
const PSFCPRESFORlivrablesIngenieurieSociauxGuideEntretienDiscussion =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/ActivitesDialogueRenforceMemorandum/GuideEntretienDiscussion/index')
  );
const PSFCPRESFORlivrablesIngenieurieSociauxMethodologieProtocoleGestion =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/ActivitesDialogueRenforceMemorandum/MethodologieProtocoleGestion/index')
  );
const PSFCPRESFORlivrablesIngenieurieSociauxProcesVerbalConstatAchevement =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/ActivitesDialogueRenforceMemorandum/ProcesVerbalConstatAchevement/index')
  );

const PSFCPRESFORlivrablesIngenieurieSociauxProcesVerbaleClarification =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/ActivitesDialogueRenforceMemorandum/ProcesVerbaleClarification/index')
  );

const PSFCPRESFORlivrablesIngenieurieSociauxProcesVerbaleClarificationCreate =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/ActivitesDialogueRenforceMemorandum/ProcesVerbaleClarification/create/index')
  );

const PSFCPRESFORlivrablesIngenieurieSociauxProcesVerbaleClarificationA =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/ActivitesDialogueRenforceMemorandum/ProcesVerbaleClarification/create/ProcesVerbaleClarificationA/index')
  );
const PSFCPRESFORlivrablesIngenieurieSociauxProcesVerbaleClarificationB =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/ActivitesDialogueRenforceMemorandum/ProcesVerbaleClarification/create/ProcesVerbaleClarificationB/index')
  );

const PSFCPRESFORlivrablesIngenieurieSociauxModeleProposeCourrierTransmission =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/ElaborationCalendrier/ModeleProposeCourrierTransmission/index')
  );

const PSFCPRESFORlivrablesIngenieurieSociauxCalendrierPrevisionnelPremiereActivite =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/ElaborationCalendrier/CalendrierPrevisionnelPremiereActivite/index')
  );

const PSFCPRESFORlivrablesIngenieurieSociauxProcesVerbaleClarificationC =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/ActivitesDialogueRenforceMemorandum/ProcesVerbaleClarification/create/ProcesVerbaleClarificationC/index')
  );
const PSFCPRESFORlivrablesIngenieurieSociauxProcesVerbalReglementLitige =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/ActivitesDialogueRenforceMemorandum/ProcesVerbalReglementLitige/index')
  );
const PSFCPRESFORlivrablesIngenieurieSociauxProcesVerbalReglementLitigeCreate =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/ActivitesDialogueRenforceMemorandum/ProcesVerbalReglementLitige/create/index')
  );

const PSFCPRESFORlivrablesIngenieurieSociauxRapportIsf = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/InformationSensibilisationActeursVillageois/rapport-isf')
);

const PSFCPRESFORlivrablesIngenieurieSociauxModelProposeListePresenceReunionInformationSensibilisation =
  React.lazy(
    () =>
      import('pages/Projets/DigiFor/Presfor/IngenieurieSociauxFonciere/ISFPrealable/InformationSensibilisationActeursVillageois/model-propose-liste-presence-reunion-information-sensibilisation')
  );

// Dashboard Presfor Routes
const AdminPresforPage = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Admin/AdminPresforPage')
);
const ContractPresfor = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Admin/AdminPresforPage')
);
const CertificatPresfor = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Admin/AdminPresforPage')
);
const SettingPresfor = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Admin/AdminPresforPage')
);
const NotificationPresfor = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Admin/AdminPresforPage')
);
const CorbeillePresfor = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Admin/AdminPresforPage')
);
const AuditTransmissionsPresfor = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Admin/AdminPresforPage')
);
const OtaPresfor = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Admin/AdminPresforPage')
);
const UserPresfor = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Admin/AdminPresforPage')
);
const AddUserPresfor = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Admin/AdminPresforPage/add-user')
);
const Dtv = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Admin/AdminPresforPage')
);
const IsfComplementaire = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Admin/AdminPresforPage')
);
const IsfPrealable = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Admin/AdminPresforPage')
);
const IsfTransmission = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Admin/AdminPresforPage')
);
const IsfValidate = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Admin/AdminPresforPage')
);
const DcfValidate = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Admin/AdminPresforPage')
);
const Objectifs = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Admin/AdminPresforPage')
);
const PvrdcQuestionnaire = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF3/PvrdcQuestionnaire')
);

const PSFCPRESFORVALIDATIONSPAGE = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Enquete/PSFCPRESFORVALIDATIONSPAGE')
);

const PSFCPRESFORVALIDATIONSCONTRAT = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Enquete/PSFCPRESFORVALIDATIONSCONTRAT')
);

const PSFCPRESFORDemandesAFOR = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Enquete/PSFCPRESFORDemandesAFOR')
);

const PSFCPRESFORDemandesPresATransmettre = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Enquete/PSFCPRESFORDemandesPresATransmettre')
);

const UpdateAnnexesPVCL = React.lazy(
  () =>
    import('pages/Projets/DigiFor/Presfor/Certifications/CF4/AddAnnexesPVCL/update')
);

const Rapports = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Admin/AdminPresforPage')
);

const RapportsDTV = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Admin/AdminPresforPage/rapport-dtv')
);
const RapportsContrats = React.lazy(
  () => import('pages/Projets/DigiFor/Presfor/Admin/AdminPresforPage/rapports-contrats')
);

const PresforRoutes = (
  <>
    {/* ======================================================== */}
    {/* =============== AUTHENTIFICATION ROUTES ================ */}
    {/* ======================================================== */}
    <Route path="/psfcsignin" element={<PSFCSignin />} />
    <Route path="/psfcseconnecter" element={<PSFCSeconnecter />} />
    <Route path="/psfcmdpoublie" element={<PSFCMdpoublie />} />
    <Route path="/psfcreinitialisermdp" element={<PSFCReinitialisermdp />} />
    <Route path="/psfcmenuprofil" element={<PSFCMenuprofil />} />
    <Route
      path="/psfcprofil"
      element={<ProtectedRoute element={PSFCProfil} />}
    />
    {/* ======================================================== */}
    {/* ================= ERROR HANDLING ROUTES ================ */}
    {/* ======================================================== */}
    {/* <Route path="/error" element={<ProtectedRoute element={ErrorBoundary} />} /> */}
    {/* <Route path="*" element={<NotFound />} /> */}
    {/* ======================================================== */}
    {/* =================== ADMIN ROUTES ====================== */}
    {/* ======================================================== */}
    <Route path="/AdminPresforPage" element={<AdminPresforPage />}>
      <Route path="user" element={<UserPresfor />} />
      <Route path="user/add" element={<AddUserPresfor />} />
      <Route path="ota" element={<OtaPresfor />} />
      <Route path="objectifs" element={<Objectifs />} />
      <Route path="rapports" element={<Rapports />} />
      <Route path="rapports/dtv" element={<RapportsDTV />} />
      <Route path="rapports/contrats" element={<RapportsContrats />} />
      <Route path="isf-prealable" element={<IsfPrealable />} />
      <Route path="isf-complementaire" element={<IsfComplementaire />} />
      <Route path="transmission" element={<IsfTransmission />} />
      <Route path="isf-valide" element={<IsfValidate />} />
      <Route path="cf-valide" element={<DcfValidate />} />
      <Route path="dtv" element={<Dtv />} />
      <Route path="contract" element={<ContractPresfor />} />
      <Route path="certificat" element={<CertificatPresfor />} />
      <Route path="setting" element={<SettingPresfor />} />
      <Route path="notification" element={<NotificationPresfor />} />
      <Route path="corbeille" element={<CorbeillePresfor />} />
      <Route path="audit-transmissions" element={<AuditTransmissionsPresfor />} />
    </Route>
    {/* <Route path="/AdminHomePagePresfor" element={<AdminHomePage />}>
      <Route path="user" element={<User />} />
      <Route path="ota" element={<Ota />} />
      <Route path="contract" element={<Contract />} />
      <Route path="certificat" element={<Certificat />} />
      <Route path="setting" element={<Setting />} />
      <Route path="notification" element={<Notification />} />
      <Route path="corbeille" element={<Corbeille />} />
    </Route> */}
    {/* ======================================================== */}
    {/* ============== ACCUEIL & ROUTES GÉNÉRALES ============== */}
    {/* ======================================================== */}
    {/* <Route path="/" element={<PSFCHome />} /> */}
    {/* <Route path="/contact" element={<Contact />} />
    <Route path="/psfcprojets" element={<ProtectedRoute element={PSFCProjets} />} />
    <Route path="/projets" element={<ProtectedRoute element={Projets} />} />
    <Route path="/foncierurbaineprojets" element={<ProtectedRoute element={FUProjets} />} />
    <Route path="/autresprojets" element={<ProtectedRoute element={OtherProjets} />} />
    <Route path="/service/demande" element={<ProtectedRoute element={ServicesDemande} />} />
    <Route path="/psfcpresfor" element={<ProtectedRoute element={PSFCPRESFOR} />} /> */}
    {/* ======================================================== */}
    {/* ================= DÉLIMITATION (DTV) =================== */}
    {/* ======================================================== */}
    <Route
      path="/psfcpresfor"
      element={<ProtectedRoute element={PSFCPRESFOR} />}
    />
    <Route
      path="/psfcpresfor/validations"
      element={<ProtectedRoute element={PSFCPRESFORVALIDATIONSPAGE} />}
    />
    <Route
      path="/psfcpresfor/validations-contrats"
      element={<ProtectedRoute element={PSFCPRESFORVALIDATIONSCONTRAT} />}
    />
    <Route
      path="/psfcpresfor/demandes-afor"
      element={<ProtectedRoute element={PSFCPRESFORDemandesAFOR} />}
    />
    <Route
      path="/psfcpresfor/demandes-pres-a-transmettre"
      element={<ProtectedRoute element={PSFCPRESFORDemandesPresATransmettre} />}
    />
    {/* Historique et Constitution */}
    <Route
      path="/dtv/historique-constitution"
      element={<ProtectedRoute element={DTVAddHistoriqueConstitution} />}
    />
    <Route
      path="/dtv/historique-constitution-liste"
      element={
        <ProtectedRoute element={DTVAddHistoriqueConstitutionListePresence} />
      }
    />
    {/* Publicité et Annonces */}
    <Route
      path="/dtv/ouverture-publicite"
      element={<ProtectedRoute element={DTVOuverturePublicite} />}
    />
    <Route
      path="/dtv/ouverture-publicite/liste-presence"
      element={
        <ProtectedRoute element={DTVAddOuverturePubliciteListePresence} />
      }
    />
    <Route
      path="/dtv/annonce-publicite"
      element={<ProtectedRoute element={DTVAnnoncePublicite} />}
    />
    <Route
      path="/cloture-pub-enquete-dtv"
      element={<PageCloturePubEnqueteDtv />}
    />
    {/* Constat et Limites */}
    <Route
      path="/dtv/constat-limite-troncon"
      element={<ProtectedRoute element={DTVAddConstatLimiteTroncon} />}
    />
    <Route
      path="/dtv/constat-limite-troncon/create"
      element={<ProtectedRoute element={DTVAddConstatLimiteTronconCreate} />}
    />
    {/* Rapports et Documents */}
    <Route
      path="/dtv/rapport-activites"
      element={<ProtectedRoute element={DTVAddRapportActivites} />}
    />
    <Route
      path="/dtv/rapport-activites/create"
      element={<ProtectedRoute element={DTVAddRapportActivitesCreate} />}
    />
    <Route
      path="/dtv/scan-document"
      element={<ProtectedRoute element={DTVAddScanDocument} />}
    />
    <Route
      path="/dtv/scan-document/create"
      element={<ProtectedRoute element={DTVAddScanDocumentCreate} />}
    />
    {/* Attestations */}
    <Route
      path="/attestation-approbation-enquete"
      element={<ProtectedRoute element={DTVAttestationApprobationEnquete} />}
    />
    <Route
      path="/attestation-validation-enquete-fonciere"
      element={<PageAttestationValidationEnqueteFonciere />}
    />
    {/* =============== VALIDATION ROUTES =============== */}
    <Route
      path="/psfcpresformodelepagevalidationcontratspagevalidationone"
      element={<PSFCPRESFORmodelepagevalidationcontratspageValidationOne />}
    />
    <Route
      path="/psfcpresformodelepagevalidationcontratsrejetcgeds"
      element={<PSFCPRESFORmodelepagevalidationcontratsRejetCGEDS />}
    />
    <Route
      path="/psfcpresformodelepagevalidationcontratspagevalidationfive"
      element={<PSFCPRESFORmodelepagevalidationcontratspageValidationFive />}
    />
    <Route
      path="/psfcpresformodelepagevalidationcontratspagevalidationtwo"
      element={<PSFCPRESFORmodelepagevalidationcontratspageValidationTwo />}
    />
    <Route
      path="/psfcpresformodelepagevalidationcontratspagevalidationthree"
      element={<PSFCPRESFORmodelepagevalidationcontratspageValidationThree />}
    />
    <Route
      path="/psfcpresformodelepagevalidationcontratspagevalidationfour"
      element={<PSFCPRESFORmodelepagevalidationcontratspageValidationFour />}
    />
    <Route
      path="/psfcpresformodelepagevalidationcontratspagevalidationfour1"
      element={<PSFCPRESFORmodelepagevalidationcontratspageValidationFour1 />}
    />
    <Route
      path="/psfcpresformodelepagevalidationcontratspagevalidationone1"
      element={<PSFCPRESFORmodelepagevalidationcontratspageValidationOne1 />}
    />
    <Route
      path="/psfcpresformodelepagevalidationcontratspagevalidation1"
      element={<PSFCPRESFORmodelepagevalidationcontratspageValidation1 />}
    />
    <Route
      path="/psfcpresformodelepagevalidationcontratspagevalidationsix"
      element={<PSFCPRESFORmodelepagevalidationcontratspageValidationSix />}
    />
    {/* =============== CONTRACT ROUTES =============== */}
    <Route
      path="/resumecontrat"
      element={<ProtectedRoute element={Resumecontrat} />}
    />
    {/* =============== ENQUETE ROUTES =============== */}
    <Route
      path="/psfcpresforcreerenqute"
      element={<ProtectedRoute element={PSFCPRESFORcreerEnqute} />}
    />
    <Route
      path="/psfcpresforenqpromocontratenquetecreee"
      element={
        <ProtectedRoute element={PSFCPRESFOREnqPromoContratenqueteCreee} />
      }
    />
    <Route
      path="/psfcpresforenqpromocontratenquetecreee/prefecture"
      element={
        <ProtectedRoute
          element={PSFCPRESFOREnqPromoContratenqueteListPrefecture}
        />
      }
    />
    <Route
      path="/psfcpresforenqpromocontrat"
      element={<ProtectedRoute element={PSFCPRESFOREnqPromoContrat} />}
    />
    <Route
      path="/psfcpresforenqcf"
      element={<ProtectedRoute element={PSFCPRESFORENQCF} />}
    />
    <Route
      path="/psfcpresforenqcf/dossier-non-valide"
      element={<ProtectedRoute element={DossierNonValides} />}
    />
    <Route
      path="/demandeenqcf"
      element={<ProtectedRoute element={DemandeEnqCF} />}
    />{' '}
    {/* =============== LIVRABLES ROUTES =============== */}
    {/* Ingénieurie Sociaux */}
    <Route
      path="/psfcpresforlivrablesIngenieurieSociaux"
      element={
        <ProtectedRoute element={PSFCPRESFORlivrablesIngenieurieSociaux} />
      }
    />
    <Route
      path="/PSFCPRESFORlivrablesIngenieurieSociauxValides"
      element={
        <ProtectedRoute
          element={PSFCPRESFORlivrablesIngenieurieSociauxValides}
        />
      }
    />
    <Route
      path="/PSFCPRESFORlivrablesIngenieurieSociauxRejete"
      element={
        <ProtectedRoute
          element={PSFCPRESFORlivrablesIngenieurieSociauxRejete}
        />
      }
    />
    <Route
      path="/PSFCPRESFORlivrablesIngenieurieSociauxEnCours"
      element={
        <ProtectedRoute
          element={PSFCPRESFORlivrablesIngenieurieSociauxEnCours}
        />
      }
    />
    <Route
      path="/PSFCPRESFORlivrablesIngenieurieSociauxRevus"
      element={
        <ProtectedRoute element={PSFCPRESFORlivrablesIngenieurieSociauxRevus} />
      }
    />
    <Route
      path="/psfcpresforlivrablesIngenieurieSociauxSousPrefecture"
      element={
        <ProtectedRoute
          element={PSFCPRESFORlivrablesIngenieurieSociauxSousPrefecture}
        />
      }
    />
    {/* Sensibilisation */}
    <Route
      path="/psfcpresforlivrablessensiblisation"
      element={<ProtectedRoute element={PSFCPRESFORLivrablesSensibilisation} />}
    />
    {/* Clôture */}
    <Route
      path="/psfcpresforlivrablescloture"
      element={<ProtectedRoute element={PSFCPRESFORLivrablesCloture} />}
    />
    {/* Délimitation */}
    <Route
      path="/psfcpresforlivrablesdelimitation"
      element={<ProtectedRoute element={PSFCPRESFORLivrablesDelimitation} />}
    />
    <Route
      path="/psfcpresforlivrablesdelimitationValide"
      element={
        <ProtectedRoute element={PSFCPRESFORLivrablesDelimitationValide} />
      }
    />
    <Route
      path="/psfcpresforlivrablesdelimitationNonValide"
      element={
        <ProtectedRoute element={PSFCPRESFORLivrablesDelimitationNonValide} />
      }
    />
    <Route
      path="/psfcpresforlivrablesdelimitationRejete"
      element={
        <ProtectedRoute element={PSFCPRESFORLivrablesDelimitationRejete} />
      }
    />
    <Route
      path="/psfcpresforlivrablesdelimitationRevus"
      element={
        <ProtectedRoute element={PSFCPRESFORLivrablesDelimitationRevus} />
      }
    />
    {/* Cérémonie */}
    <Route
      path="/model-propose-ceremonie-ouverture"
      element={
        <ProtectedRoute
          element={PSFCPRESFORlivrablesIngenieurieSociauxCeremonieOuverture}
        />
      }
    />
    <Route
      path="/model-propose-courrier-transmission"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxModeleProposeCourrierTransmission
          }
        />
      }
    />{' '}
    {/* =============== CALENDRIER ET PLANIFICATION ROUTES =============== */}
    <Route
      path="/calendrier-previsionnel-premiere-activite"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxCalendrierPrevisionnelPremiereActivite
          }
        />
      }
    />
    <Route
      path="/calendrier-ceremonie-ouverture"
      element={
        <ProtectedRoute
          element={PSFCPRESFORlivrablesIngenieurieSociauxCalendrierOuverture}
        />
      }
    />
    <Route
      path="/calendrier-previsionnel-activites"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxCalendrierPrevisionnelActivites
          }
        />
      }
    />
    {/* =============== PRISE DE CONTACT ROUTES =============== */}
    <Route
      path="/compte-rendu-de-prise-de-contact"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxPriseDeContactCompteRendu
          }
        />
      }
    />
    <Route
      path="/compte-rendu-de-prise-de-contact/sous-prefecture"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxPriseDeContactCompteRenduSousPrefecture
          }
        />
      }
    />
    <Route
      path="/liste-de-presence-de-prise-de-contact"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxPriseDeContactListeDePresence
          }
        />
      }
    />
    <Route
      path="/liste-de-presence-de-prise-de-contact/sous-prefecture"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxPriseDeContactListeDePresenceSousPrefecture
          }
        />
      }
    />{' '}
    {/* =============== RECUEIL DE DONNÉES ROUTES =============== */}
    <Route
      path="/liste-de-presence-recueil"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxPriseDeContactListeDePresenceRecueil
          }
        />
      }
    />{' '}
    <Route
      path="/recueil-donnees-personnelles"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxPriseDeContactRecueilDonneesPersonnelles
          }
        />
      }
    />
    <Route
      path="/recueil-donnees-personnelles/sous-prefecture"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxPriseDeContactRecueilDonneesPersonnellesSousPrefecture
          }
        />
      }
    />
    <Route
      path="/recueil-donnees-personnelles/sous-prefecture/create"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxPriseDeContactRecueilDonneesPersonnellesSousPrefectureCreate
          }
        />
      }
    />
    {/* =============== CONSOLIDATION ROUTES =============== */}
    <Route
      path="/psfcpresforconsolidationdispositifs"
      element={<ProtectedRoute element={PSFCPRESFORLivrablesConsolidation} />}
    />
    <Route
      path="/psfcpresforconsolidationdroits"
      element={
        <ProtectedRoute element={PSFCPRESFORLivrablesConsolidationDroits} />
      }
    />
    <Route
      path="/consodispo/attestationformationaefj"
      element={
        <ProtectedRoute element={ConsolidationAttestationFormationAEFJ} />
      }
    />
    <Route
      path="/consodispo/attestationformationaefc"
      element={
        <ProtectedRoute element={ConsolidationAttestationFormationAEFC} />
      }
    />
    <Route
      path="/model-propose-compte-rendu"
      element={
        <ProtectedRoute
          element={PSFCPRESFORlivrablesIngenieurieSociauxCompteRendu}
        />
      }
    />
    <Route
      path="/decision-creation-cvgfr"
      element={
        <ProtectedRoute
          element={PSFCPRESFORlivrablesIngenieurieSociauxDecisionCreation}
        />
      }
    />
    <Route
      path="/reunion-periodique-decision-sous-prefectorale"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxReunionPeriodiqueDecisionSousPrefectorale
          }
        />
      }
    />
    <Route
      path="/reunion-periodique-decision-sous-prefectorale/sous-prefecture/create"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxReunionPeriodiqueDecisionSousPrefectoraleSousPrefectureCreate
          }
        />
      }
    />
    <Route
      path="/reunion-periodique-decision-sous-prefectorale/sous-prefecture"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxReunionPeriodiqueDecisionSousPrefectoraleSousPrefecture
          }
        />
      }
    />
    <Route
      path="/reunion-periodique-sous-prefectorale/sous-prefecture"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxReunionPeriodiqueSousPrefectorale
          }
        />
      }
    />
    {/* <Route
      path="/decision-sous-prefectorale"
      element={
        <ProtectedRoute
          element={PSFCPRESFORISFDesignationActivitesDialogueSocial}
        />
      }
    /> */}
    {/* <Route
      path="/resolutions-des-reunions-cspisf"
      element={
        <ProtectedRoute element={PSFCPRESFORISFResolutionsdesReunionsCSPISF} />
      }
    /> */}
    <Route
      path="/proces-verbal-cvgfr"
      element={
        <ProtectedRoute
          element={PSFCPRESFORlivrablesIngenieurieSociauxProcesVerbal}
        />
      }
    />
    <Route
      path="/rapport-sur-le-deroulement-des-activites"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxRapportSurLeDeroulementDesActivités
          }
        />
      }
    />
    <Route
      path="/attestation-formation-cvgfr"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxAttestationFormationCvgfr
          }
        />
      }
    />
    <Route
      path="/livrable-cvgfr"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxDiagnosticCvgfrLivrable
          }
        />
      }
    />
    <Route
      path="/cahiers-intentions-cf"
      element={
        <ProtectedRoute
          element={PSFCPRESFORlivrablesIngenieurieSociauxCahiersIntentionsCF}
        />
      }
    />
    <Route
      path="/cahiers-intentions-contrat"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxCahiersIntentionsContrat
          }
        />
      }
    />
    <Route
      path="/psfcpresforconsolidationdispositifs"
      element={<ProtectedRoute element={PSFCPRESFORLivrablesConsolidation} />}
    />
    <Route
      path="/psfcpresforconsolidationdroits"
      element={
        <ProtectedRoute element={PSFCPRESFORLivrablesConsolidationDroits} />
      }
    />
    <Route
      path="/consodispo/attestationformationaefj"
      element={
        <ProtectedRoute element={ConsolidationAttestationFormationAEFJ} />
      }
    />
    <Route
      path="/consodispo/attestationformationaefc"
      element={
        <ProtectedRoute element={ConsolidationAttestationFormationAEFC} />
      }
    />
    <Route
      path="/psfcpresforenqpromocontrat"
      element={<ProtectedRoute element={PSFCPRESFOREnqPromoContrat} />}
    />
    <Route
      path="/psfcpresforenqpromocontrataddcontrat"
      element={
        <ProtectedRoute element={PSFCPRESFOREnqPromoContrataddContrat} />
      }
    />
    <Route
      path="/contrat-plantation-agroforesterie"
      element={<ProtectedRoute element={ContratPlantationAgroforesterie} />}
    />
    <Route
      path="/contrat-terre-agroforesterie"
      element={<ProtectedRoute element={ContratTerreAgroforesterie} />}
    />
    <Route
      path="/contrat-recolte-agroforesterie"
      element={<ProtectedRoute element={ContratRecolteAgroforesterie} />}
    />
    <Route
      path="/contrat-location-agroforesterie"
      element={<ProtectedRoute element={ContratLocationAgroforesterie} />}
    />
    <Route
      path="/contrat-metayage-agroforesterie"
      element={<ProtectedRoute element={ContratMetayageAgroforesterie} />}
    />
    <Route
      path="/contrat-garantie-agroforesterie"
      element={<ProtectedRoute element={ContratGarantieAgroforesterie} />}
    />
    <Route
      path="/contrat-pret-agroforesterie"
      element={<ProtectedRoute element={ContratPretAgroforesterie} />}
    />
    <Route
      path="/contrat-jachere-agroforesterie"
      element={<ProtectedRoute element={ContratJachereAgroforesterie} />}
    />
    <Route
      path="/contrat-location-agri-elevage"
      element={<ProtectedRoute element={ContratLocationAgriElevage} />}
    />
    <Route
      path="/contrat-location-paturage-permanent"
      element={<ProtectedRoute element={ContratLocationPaturagePermanent} />}
    />
    <Route
      path="/contrat-location-paturage-saisonnier"
      element={<ProtectedRoute element={ContratLocationPaturageSaisonnier} />}
    />
    <Route
      path="/sous-contrat-location-paturage-saisonnier"
      element={<ProtectedRoute element={ContratSousLocationPaturageSaisonnier} />}
    />
    {/* Alias historique (éditions / liens anciens) */}
    <Route
      path="/contrat-sous-location-paturage-saisonnier"
      element={<ProtectedRoute element={ContratSousLocationPaturageSaisonnier} />}
    />
    <Route
      path="/contrat-pret-agri-elevage"
      element={<ProtectedRoute element={ContratPretAgriElevage} />}
    />
    <Route
      path="/contrat-pret-paturage-permanent"
      element={<ProtectedRoute element={ContratPretPaturagePermanent} />}
    />
    <Route
      path="/contrat-pret-paturage-saisonnier"
      element={<ProtectedRoute element={ContratPretPaturageSaisonnier} />}
    />
    <Route
      path="/sous-contrat-pret-paturage-saisonnier"
      element={<ProtectedRoute element={ContratSousPretPaturageSaisonnier} />}
    />
    <Route
      path="/contrat-sous-pret-paturage-saisonnier"
      element={<ProtectedRoute element={ContratSousPretPaturageSaisonnier} />}
    />
    <Route
      path="/contrat-pret-collectivite-territoriale"
      element={
        <ProtectedRoute element={ContratPretCollectiviteTerritoriale} />
      }
    />
    <Route
      path="/psfcpresforenqpromocontratupdatecontrat"
      element={
        <ProtectedRoute element={PSFCPRESFOREnqPromoContratUpdateContrat} />
      }
    />
    <Route
      path="/psfcpresforlivrablescf"
      element={<ProtectedRoute element={PSFCPRESFORlivrablescf} />}
    />
    <Route
      path="/psfcpresforenqcf"
      element={<ProtectedRoute element={PSFCPRESFORENQCF} />}
    />{' '}
    {/* =============== CERTIFICATION ROUTES =============== */}
    {/* Base Certification Routes */}
    <Route path="/addcf" element={<ProtectedRoute element={AddCF} />} />
    <Route path="/editcf" element={<ProtectedRoute element={EditCF} />} />
    <Route
      path="/addficheidentification"
      element={<ProtectedRoute element={AddFicheIdentification} />}
    />
    <Route path="/addcfinfo" element={<ProtectedRoute element={AddCFInfo} />} />
    <Route path="/infooptcf" element={<ProtectedRoute element={InfoOPTCF} />} />
    <Route
      path="/psfcpresforlivrablescf"
      element={<ProtectedRoute element={PSFCPRESFORlivrablescf} />}
    />
    {/* CF Specific Routes */}
    <Route path="/cf1" element={<CF1 />} />
    <Route path="/cf4" element={<ProtectedRoute element={CF4} />} />
    <Route path="/cf8" element={<ProtectedRoute element={CF8} />} />
    <Route path="/cf9" element={<ProtectedRoute element={CF9} />} />
    <Route path="/cf10" element={<ProtectedRoute element={CF10} />} />
    <Route path="/cf11" element={<ProtectedRoute element={CF11} />} />
    <Route path="/cf12" element={<ProtectedRoute element={CF12} />} />
    <Route path="/cf19" element={<ProtectedRoute element={CF19} />} />
    <Route path="/cf20" element={<ProtectedRoute element={CF20} />} />
    {/* Litige et Droits Routes */}
    <Route
      path="/FicheLitigesCF"
      element={<ProtectedRoute element={FicheLitigesCF} />}
    />
    <Route
      path="/EtatDesDroitsDeProp"
      element={<ProtectedRoute element={EtatDesDroitsDeProp} />}
    />
    <Route
      path="/ListeDetenteursDeDroitsCF"
      element={<ProtectedRoute element={ListeDetenteursDeDroitsCF} />}
    />
    <Route
      path="/ListeDesServitudes"
      element={<ProtectedRoute element={ListeDesServitudes} />}
    />
    <Route
      path="/DocumentsAnnexePVRDC"
      element={<ProtectedRoute element={DocumentsAnnexePVRDC} />}
    />
    <Route
      path="/addDocumentsAnnexePVRDC"
      element={<ProtectedRoute element={ModalUploadDocumentsAnnexePVRDC} />}
    />
    <Route
      path="/ListeDesAyantsDroitsCF"
      element={<ProtectedRoute element={ListeDesAyantsDroitsCF} />}
    />
    {/* Publication Routes */}
    <Route path="/pub" element={<ProtectedRoute element={PUB} />} />
    <Route
      path="/addannexesouverturepub"
      element={<ProtectedRoute element={AddAnnexesOuverturePub} />}
    />
    <Route
      path="/addouverturepub"
      element={<ProtectedRoute element={AddOuverturePub} />}
    />
    <Route
      path="/addenqueteouverturepub"
      element={<ProtectedRoute element={AddEnqueteOuverturePub} />}
    />
    <Route
      path="/addannexespvpub"
      element={<ProtectedRoute element={AddAnnexesPVPub} />}
    />
    <Route path="/addpvpub" element={<ProtectedRoute element={AddPVPub} />} />
    <Route path="/addcf19" element={<ProtectedRoute element={AddCf19} />} />
    <Route
      path="/addannexesannoncepub"
      element={<ProtectedRoute element={AddAnnexesAnnoncePub} />}
    />
    <Route
      path="/addannoncepub"
      element={<ProtectedRoute element={AddAnnoncePub} />}
    />
    {/* Gestionnaire Routes */}
    <Route
      path="/GestionnaireCF"
      element={<ProtectedRoute element={GestionnaireCF} />}
    />
    <Route
      path="/updateGestionnaireCF"
      element={<ProtectedRoute element={UpdateGestionnaireCF} />}
    />
    <Route
      path="/uodateGestionnaireCF"
      element={<ProtectedRoute element={UpdateGestionnaireCF} />}
    />
    <Route
      path="/SignatairesDesignationGestionnaire"
      element={<ProtectedRoute element={SignatairesDesignationGestionnaire} />}
    />
    {/* Validation Routes */}
    <Route
      path="/addannexesvalidation"
      element={<ProtectedRoute element={AddAnnexesValidation} />}
    />
    <Route
      path="/addvalidation"
      element={<ProtectedRoute element={AddValidation} />}
    />
    <Route
      path="/addvalidation-annonce"
      element={<ProtectedRoute element={AddValidationAnnonce} />}
    />
    <Route
      path="/addannexesvalidation-annonce"
      element={<ProtectedRoute element={AddAnnexesValidationAnnonce} />}
    />
    <Route
      path="/editvalidation-annonce"
      element={<ProtectedRoute element={EditValidationAnnonce} />}
    />
    <Route
      path="/editannexesvalidation-annonce"
      element={<ProtectedRoute element={EditAnnexesValidationAnnonce} />}
    />
    <Route
      path="/addannexescecpdc"
      element={<ProtectedRoute element={AddAnnexesCECPDC} />}
    />
    <Route path="/addcecpdc" element={<ProtectedRoute element={AddCECPDC} />} />
    <Route
      path="/editcecpdc"
      element={<ProtectedRoute element={EditCECPDC} />}
    />
    <Route
      path="/editannexescecpdc"
      element={<ProtectedRoute element={EditAnnexesCECPDC} />}
    />
    <Route
      path="/addcecpdc-dcf"
      element={<ProtectedRoute element={AddCECPDCDcf} />}
    />
    <Route
      path="/editcecpdc-dcf"
      element={<ProtectedRoute element={EditCECPDCDcf} />}
    />
    <Route
      path="/addannexescecpdc-dcf"
      element={<ProtectedRoute element={AddAnnexesCECPDCDcf} />}
    />
    <Route
      path="/editannexescecpdc-dcf"
      element={<ProtectedRoute element={EditAnnexesCECPDCDcf} />}
    />
    {/* PV Routes */}
    <Route
      path="/pvrdcTemplate"
      element={<ProtectedRoute element={PVRDCTemplate} />}
    />
    <Route
      path="/addannexespvcl"
      element={<ProtectedRoute element={AddAnnexesPVCL} />}
    />
    <Route
      path="/updateannexespvcl"
      element={<ProtectedRoute element={UpdateAnnexesPVCL} />}
    />
    <Route
      path="/pvcl-annexe"
      element={<ProtectedRoute element={AddDemandePVCLAnnexes} />}
    />
    <Route
      path="/addannexesclp"
      element={<ProtectedRoute element={AddAnnexesCLP} />}
    />
    <Route path="/addpvcl" element={<ProtectedRoute element={AddPVCL} />} />
    <Route
      path="/addrapportnonparticipation"
      element={<ProtectedRoute element={AddRapportNonParticipation} />}
    />
    <Route
      path="/addrapportnonparticipation/page1"
      element={<ProtectedRoute element={FormulairePage1} />}
    />
    <Route
      path="/addrapportnonparticipation/page2"
      element={<ProtectedRoute element={FormulairePage2} />}
    />
    <Route
      path="/adddemandepvcl"
      element={<ProtectedRoute element={AddDemandePVCL} />}
    />
    <Route
      path="/demandepvcl"
      element={<ProtectedRoute element={DemandePVCL} />}
    />
    <Route path="/addclp" element={<ProtectedRoute element={AddCLP} />} />
    <Route path="/pvrdc" element={<ProtectedRoute element={PVRDC} />} />
    <Route
      path="/listepvrdc"
      element={<ProtectedRoute element={ListePVRDC} />}
    />
    {/* Info Routes */}
    <Route
      path="/fichedemographiquecf"
      element={<ProtectedRoute element={FicheDemographiqueCF} />}
    />
    <Route
      path="/AutresDeclarationsCF"
      element={<ProtectedRoute element={AutresDeclarationsCF} />}
    />
    <Route
      path="/InfoOccuppantsParcelle"
      element={<ProtectedRoute element={InfoOccupantsParcelle} />}
    />
    <Route
      path="/QuestionnaireCF"
      element={<ProtectedRoute element={QuestionnaireCF} />}
    />{' '}
    <Route
      path="/PvrdcQuestionnaire"
      element={<ProtectedRoute element={PvrdcQuestionnaire} />}
    />{' '}
    =============== CONTRACT ROUTES ===============
    {/* Contrat Base Routes */}
    <Route
      path="/Addcontratone"
      element={<ProtectedRoute element={Addcontratone} />}
    />
    <Route
      path="/AddcontratoneUpdate"
      element={<ProtectedRoute element={Addcontratoneupdate} />}
    />
    <Route
      path="/psfcpresforlisteannexescontrat"
      element={<ProtectedRoute element={listeAnnexesContrat} />}
    />
    <Route
      path="/psfcpresforenqpromocontrataddcontrat"
      element={
        <ProtectedRoute element={PSFCPRESFOREnqPromoContrataddContrat} />
      }
    />
    <Route
      path="/psfcpresforenqpromocontratupdatecontrat"
      element={
        <ProtectedRoute element={PSFCPRESFOREnqPromoContratUpdateContrat} />
      }
    />
    {/* Contrat Donation Routes */}
    <Route
      path="/psfcpresforenqpromocontratcontratdonationptwo"
      element={
        <ProtectedRoute
          element={PSFCPRESFOREnqPromoContratContratdonationpTwo}
        />
      }
    />
    <Route
      path="/psfcpresforenqpromocontratcontratdonationptwoupdate"
      element={
        <ProtectedRoute
          element={PSFCPRESFOREnqPromoContratContratdonationpTwoUpdate}
        />
      }
    />
    <Route
      path="/psfcpresforenqpromocontratcontratdonationpthree"
      element={
        <ProtectedRoute
          element={PSFCPRESFOREnqPromoContratContratdonationpThree}
        />
      }
    />
    <Route
      path="/psfcpresforenqpromocontratcontratdonationpthreeUpdate"
      element={
        <ProtectedRoute
          element={PSFCPRESFOREnqPromoContratContratdonationpThreeUpdate}
        />
      }
    />
    <Route
      path="/psfcpresforenqpromocontratcontratdonationpfour"
      element={
        <ProtectedRoute
          element={PSFCPRESFOREnqPromoContratContratdonationpFour}
        />
      }
    />
    <Route
      path="/psfcpresforenqpromocontratcontratdonationpfourupdate"
      element={
        <ProtectedRoute
          element={PSFCPRESFOREnqPromoContratContratdonationpFourUpdate}
        />
      }
    />
    <Route
      path="/psfcpresforenqpromocontratcontratdonationpfive"
      element={
        <ProtectedRoute
          element={PSFCPRESFOREnqPromoContratContratdonationpFive}
        />
      }
    />
    <Route
      path="/psfcpresforenqpromocontratcontratdonationpfiveupdate"
      element={
        <ProtectedRoute
          element={PSFCPRESFOREnqPromoContratContratdonationpFiveUpdate}
        />
      }
    />
    <Route
      path="/psfcpresforenqpromocontratcontratdonationpsix"
      element={
        <ProtectedRoute
          element={PSFCPRESFOREnqPromoContratContratdonationpSix}
        />
      }
    />
    <Route
      path="/psfcpresforenqpromocontratcontratdonationpsixupdate"
      element={
        <ProtectedRoute
          element={PSFCPRESFOREnqPromoContratContratdonationpSixUpdate}
        />
      }
    />
    <Route
      path="/psfcpresforenqpromocontratcontratdonationpseven"
      element={
        <ProtectedRoute
          element={PSFCPRESFOREnqPromoContratContratdonationpSeven}
        />
      }
    />
    <Route
      path="/psfcpresforenqpromocontratcontratdonationpsevenupdate"
      element={
        <ProtectedRoute
          element={PSFCPRESFOREnqPromoContratContratdonationpSevenUpdate}
        />
      }
    />
    <Route
      path="/psfcpresforenqpromocontratcontratdonationpeight"
      element={
        <ProtectedRoute
          element={PSFCPRESFOREnqPromoContratContratdonationpEight}
        />
      }
    />
    <Route
      path="/psfcpresforenqpromocontratcontratdonationpeightupdate"
      element={
        <ProtectedRoute
          element={PSFCPRESFOREnqPromoContratContratdonationpEightUpdate}
        />
      }
    />
    <Route
      path="/psfcpresforenqpromocontratcontratdonationpnine"
      element={
        <ProtectedRoute
          element={PSFCPRESFOREnqPromoContratContratdonationpNine}
        />
      }
    />
    <Route
      path="/psfcpresforenqpromocontratcontratdonationpnineupdate"
      element={
        <ProtectedRoute
          element={PSFCPRESFOREnqPromoContratContratdonationpNineUpdate}
        />
      }
    />
    <Route
      path="/psfcpresforenqpromocontratcontratdonationpten"
      element={
        <ProtectedRoute
          element={PSFCPRESFOREnqPromoContratContratdonationpTen}
        />
      }
    />
    <Route
      path="/psfcpresforenqpromocontratcontratdonationptenupdate"
      element={
        <ProtectedRoute
          element={PSFCPRESFOREnqPromoContratContratdonationpTenUpdate}
        />
      }
    />{' '}
    =============== INGENIEURIE SOCIO-FONCIERE ROUTES ===============
    {/* Déclaration et Ouverture */}
    <Route
      path="/presfordeclarationouvertureoperation"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxDeclarationOuvertureOperations
          }
        />
      }
    />
    <Route
      path="/presfordeclarationouvertureoperation/sous-prefecture/liste-declaration"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxSousPrefectureListeDeclaration
          }
        />
      }
    />
    <Route
      path="/presfordeclarationouvertureoperation/sous-prefecture"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxDeclarationOuvertureOperationsSousPrefecture
          }
        />
      }
    />
    {/* Courrier et Réglementation */}
    <Route
      path="/presforcourriertransmission/sous-prefecture"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieCourrierTransSociauxSousPrefecture
          }
        />
      }
    />
    <Route
      path="/presforReglementInterieurCvgfr"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxReglementInterieurCvgfr
          }
        />
      }
    />
    {/* Réunions et Formation */}
    <Route
      path="/presforReunionPeriodiqueDecisionSousPrefectorale"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxReunionPeriodiqueDecisionSousPrefectorale
          }
        />
      }
    />
    <Route
      path="/PresforListePresenceFormationCvgfr"
      element={
        <ProtectedRoute
          element={PSFCPRESFORPresforListePresenceFormationCvgfr}
        />
      }
    />
    {/* Rapports */}
    <Route
      path="/presforRapportIsfVillage"
      element={
        <ProtectedRoute
          element={PSFCPRESFORlivrablesIngenieurieSociauxRapportIsfVillage}
        />
      }
    />
    <Route
      path="/calendrier-previsionnel-activites"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxCalendrierPrevisionnelActivites
          }
        />
      }
    />
    <Route
      path="/charte-relation-tuteur-planteur"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxCharteRelationTuteurPlanteur
          }
        />
      }
    />
    <Route
      path="/guide-entretien-discussion"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxGuideEntretienDiscussion
          }
        />
      }
    />
    <Route
      path="/methodologie-protocole-gestion"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxMethodologieProtocoleGestion
          }
        />
      }
    />
    <Route
      path="/proces-verbal-constat-achevement"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxProcesVerbalConstatAchevement
          }
        />
      }
    />
    <Route
      path="/proces-verbale-clarification/create"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxProcesVerbaleClarificationCreate
          }
        />
      }
    />
    <Route
      path="/proces-verbale-clarification"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxProcesVerbaleClarification
          }
        />
      }
    />
    <Route
      path="/proces-verbale-clarification-a"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxProcesVerbaleClarificationA
          }
        />
      }
    />
    <Route
      path="/proces-verbale-clarification-b"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxProcesVerbaleClarificationB
          }
        />
      }
    />
    <Route
      path="/proces-verbale-clarification-c"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxProcesVerbaleClarificationC
          }
        />
      }
    />
    <Route
      path="/proces-verbal-reglement-litige"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxProcesVerbalReglementLitige
          }
        />
      }
    />
    <Route
      path="/proces-verbal-reglement-litige/create"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxProcesVerbalReglementLitigeCreate
          }
        />
      }
    />
    <Route
      path="/PresforResolutionReunionsCspisf"
      element={
        <ProtectedRoute
          element={PSFCPRESFORLivrablespresforResolutionReunionsCspisf}
        />
      }
    />
    <Route
      path="/rapport-isf"
      element={
        <ProtectedRoute
          element={PSFCPRESFORlivrablesIngenieurieSociauxRapportIsf}
        />
      }
    />
    <Route
      path="/facilitation-formulaire-complementaire"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxFonciereActivitesDeFacilitation
          }
        />
      }
    />
    <Route
      path="/isf-complementaire/formation-encadrement"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxFonciereFormationEncadrement
          }
        />
      }
    />
    <Route
      path="/model-propose-liste-presence-reunion-information-sensibilisation"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxModelProposeListePresenceReunionInformationSensibilisation
          }
        />
      }
    />
    <Route
      path="/PresforProceduresEtablissementEtatCivil"
      element={
        <ProtectedRoute
          element={PSFCPRESFORlivrablespresforProceduresEtablissementEtatCivil}
        />
      }
    />
    <Route
      path="/PresforProceduresEtablissementEtatCivilCreate"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablespresforProceduresEtablissementEtatCivilCreate
          }
        />
      }
    />
    <Route
      path="/EnqueteOrganisationSocioFonciere"
      element={
        <ProtectedRoute
          element={PSFCPRESFORlivrablespresforEnqueteOrganisationSocioFonciere}
        />
      }
    />
    <Route
      path="/isf-complementaire/information-sensibilisation"
      element={
        <ProtectedRoute
          element={
            PSFCPRESFORlivrablesIngenieurieSociauxInformationSensibilisation
          }
        />
      }
    />
    <Route path="/cf1" element={<CF1 />} />
    {/* <Route path="/dhiwise-dashboard" element={<Home />} /> */}
    {/* <Route path="/dtv/constat-limite-troncon/edit/:id" element={<EditFormulaire />} /> */}
    <Route
      path="/reunion-comite-sous-prefectoral"
      element={
        <ProtectedRoute
          element={PSFCPRESFORlivrablesIngenieurieReunionComiteSousPrefectoral}
        />
      }
    />
    {/* =============== CLIENT ROUTES =============== */}
    <Route path="/client" element={<Client />} />
    <Route path="/ClientStep1" element={<ClientStep1 />} />
    <Route path="/ClientStep2" element={<ClientStep2 />} />
    <Route path="/ClientStep3" element={<ClientStep3 />} />
    <Route path="/ClientStep4" element={<ClientStep4 />} />
    <Route path="/accueil-expert" element={<ExpertHome />} />
    {/* =============== OTHER ROUTES =============== */}
    <Route path="/dhiwise-dashboard" element={<Home />} />
  </>
);

export default PresforRoutes;
